module.exports = __webpack_public_path__ + "img/oriens-text.aeab4773.svg";